// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3Xbi7","modalFooterButton":"ModalNotes_modalFooterButton__1sZ-G"};